import server from "@/api/server";

/**
 * @typedef {Object} Payment
 * @property {string} dadd
 * @property {string} reason
 * @property {string} name
 * @property {string} status
 * @property {string} sm
 */

/**
 * @typedef {Object} PaymentsResponse
 * @property {string} status - 'ok', 'err', 'redirect'
 * @property {Payment[]} list - array of payments
 * @property {number} page
 * @property {number} pageSize
 * @property {number} total
 * @property {number} sum_refill  - всего заработано
 * @property {number} sum_wo  - всего выведено
 */

/**
 * @param {Object} data
 * @param {string} data.page
 * @param {string} data.pageSize
 * @param {Array} data.filter
 * @returns {Promise<PaymentsResponse>}
 */
async function getPayments(data) {
  let res = await server.post("/agent/billing/payments/list", data);
  return res;
}

/**
 * @typedef {Object} BalanceResponse
 * @property {string} status - 'ok', 'err', 'redirect'
 * @property {number} balance_free  - баланс доступный для вывода
 */

/**
 * @returns {Promise<BalanceResponse>}
 */
async function getBalance(data, hideLoader = true) {
  let res = await server.post("/agent/billing/balance/get", data, { hideLoader });
  return res;
}

/**
 * @param {Object} param0
 * @param {'init' | 'apply'} param0.process
 * @param {string} param0.smsid
 * @param {string} param0.code
 */
async function makeWithdraw({ process, smsid, code }) {
  const data = { process };
  if (process === "apply") {
    data.smsid = smsid;
    data.code = code;
  }
  const res = await server.post("/agent/billing/payments/demand", data);
  return res;
}

// async function makeWithdraw() {
//   const res = await server.get("/agent/billing/payments/demand");
//   return res;
// }

async function prepareReport({ type, dates, ogrnList }) {
  return await server.post("/agent/billing/payments/prepare_report", {
    type: type,
    date: dates,
    ogrn_list: ogrnList
  });
}

/**
 * @param {Object} data
 * @param {string} data.page
 * @param {string} data.pageSize
 * @param {Array} data.filter
 * @returns {Promise<PaymentsResponse>}
 */
async function serverGetReportsList(data) {
  return await server.post("/agent/billing/payments/reports_list", data);
}

export { getPayments, getBalance, makeWithdraw, prepareReport, serverGetReportsList };
